var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["checkout-product", { loading: _vm.loading }] },
    [
      _vm.loading ? _c("ui-loader", { attrs: { size: "48" } }) : _vm._e(),
      _c(
        "div",
        { staticClass: "title" },
        [
          _c("div", { staticClass: "name" }, [
            _vm._v("\n      " + _vm._s(_vm.model.name) + "\n      "),
            _c("p", [_vm._v(_vm._s(_vm.model.code))])
          ]),
          _vm.editable
            ? [
                _vm.editable
                  ? _c(
                      "div",
                      {
                        staticClass: "icon-bin",
                        on: {
                          click: function($event) {
                            _vm.removeConfirm = true
                          }
                        }
                      },
                      [
                        _c("f-sprite-icon", {
                          attrs: { "icon-link": _vm.$options.icons.IconBin.id }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c("modal-confirm", {
                  attrs: {
                    visible: _vm.removeConfirm,
                    title: "Удалить товар из корзины?",
                    buttons: [
                      {
                        text: "Удалить",
                        action: _vm.remove
                      },
                      {
                        text: "Нет, оставить",
                        flat: true
                      }
                    ]
                  },
                  on: {
                    "on-close": function() {
                      return (_vm.removeConfirm = false)
                    }
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "a",
        {
          staticClass: "thumb",
          attrs: { href: _vm.productURL, target: "_blank" }
        },
        [_c("media", { attrs: { media: _vm.media, width: "192" } })],
        1
      ),
      _c("ul", { staticClass: "info" }, [
        _c("li", [
          _c("span", [_vm._v("Цвет")]),
          _vm._v(" " + _vm._s(_vm.color) + "\n    ")
        ]),
        _c("li", [
          _c("span", [_vm._v("Размер")]),
          _vm._v(" " + _vm._s(_vm.size) + "\n    ")
        ]),
        _c("li", [
          _c("span", [_vm._v("Цена")]),
          _c("div", { staticClass: "price-rub" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("price")(
                    _vm.price.discountPrice || _vm.price.basePrice
                  )
                ) +
                "\n      "
            )
          ]),
          _vm.isDiscount
            ? _c("div", { staticClass: "old-price" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("price")(_vm.price.basePrice)) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm.discounts.promotion
          ? _c("li", { staticClass: "checkout-product__promotions" }, [
              _c("div", { staticClass: "checkout-product__promotions-title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("decl")(_vm.discounts.promotion.length, "Акци", [
                        "я",
                        "и",
                        "й"
                      ])
                    ) +
                    "\n      "
                )
              ]),
              _c(
                "div",
                { staticClass: "checkout-product__promotions-inner-wrap" },
                _vm._l(_vm.discounts.promotion, function(promotion, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "checkout-product__promotion" },
                    [
                      _c(
                        "div",
                        { staticClass: "checkout-product__promotion-name" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(promotion.name) +
                              "\n          "
                          )
                        ]
                      ),
                      _c("div", { staticClass: "price price-rub discount" }, [
                        _vm._v(
                          "\n            - " +
                            _vm._s(_vm._f("price")(promotion.value)) +
                            "\n          "
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          : _vm._e(),
        _vm.discounts.promocode
          ? _c(
              "li",
              { staticClass: "checkout-product__promotions" },
              [
                _c("vue-client-only", [
                  _c(
                    "div",
                    { staticClass: "checkout-product__promotions-title" },
                    [
                      _vm.adaptive.isMobile
                        ? [_vm._v("\n            Промо\n          ")]
                        : [_vm._v("\n            Промокод\n          ")]
                    ],
                    2
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "checkout-product__promotions-inner-wrap" },
                  _vm._l(_vm.discounts.promocode, function(promotion, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "checkout-product__promotion"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "checkout-product__promotion-name" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(promotion.name) +
                                "\n          "
                            )
                          ]
                        ),
                        _c("div", { staticClass: "price price-rub discount" }, [
                          _vm._v(
                            "\n            - " +
                              _vm._s(_vm._f("price")(promotion.value)) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            )
          : _vm._e(),
        !_vm.editable && Math.floor(_vm.discount.value)
          ? _c("li", [
              _c("span", [_vm._v("\n        Скидка\n      ")]),
              _c(
                "span",
                {
                  class: [
                    "price price-rub",
                    { discount: Number(_vm.discount.value) }
                  ]
                },
                [
                  _vm._v(
                    "\n        - " +
                      _vm._s(_vm._f("price")(_vm.discount.value)) +
                      "\n      "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm.promocode && Number(_vm.promocode.value)
          ? _c(
              "li",
              [
                _c("vue-client-only", [
                  _c(
                    "span",
                    [
                      _vm.adaptive.isMobile
                        ? [_vm._v("Промо")]
                        : [_vm._v("Промокод")]
                    ],
                    2
                  ),
                  _vm._v(" " + _vm._s(_vm.promocode.name) + "\n      ")
                ]),
                _c(
                  "div",
                  {
                    class: [
                      "price price-rub",
                      { discount: _vm.promocode.value }
                    ]
                  },
                  [
                    _vm._v(
                      "\n        - " +
                        _vm._s(_vm._f("price")(_vm.promocode.value)) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "utils" }, [
        !_vm.model.available
          ? _c("div", { staticClass: "qty-info" }, [
              _vm._v("\n      Товар распродан\n    ")
            ])
          : _c(
              "div",
              { staticClass: "select checkout-product__size" },
              [
                _c("ui-select", {
                  attrs: {
                    disabled: !_vm.editable,
                    value: _vm.product.quantity,
                    options: _vm.qtyOptions
                  },
                  on: {
                    change: function(ref) {
                      var name = ref.name

                      return _vm.changeQty(name)
                    }
                  }
                })
              ],
              1
            ),
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c("favorite-button", {
              attrs: {
                "product-id": _vm.model.id,
                "product-code": _vm.model.code,
                "product-price": _vm.currentPrice,
                quantity: _vm.product.quantity,
                "sku-id": _vm.product.skuId
              }
            }),
            _vm.editable
              ? _c("f-sprite-icon", {
                  staticClass: "edit",
                  attrs: { "icon-link": _vm.$options.icons.IconEdit.id },
                  nativeOn: {
                    click: function($event) {
                      return _vm.$emit("edit")
                    }
                  }
                })
              : _vm._e(),
            _c("div", { class: ["price price-rub"] }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("price")(_vm.product.totalPrice)) +
                  "\n      "
              )
            ])
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }